import { render } from "./ResidentVital.vue?vue&type=template&id=dff56882"
import script from "./ResidentVital.vue?vue&type=script&lang=js"
export * from "./ResidentVital.vue?vue&type=script&lang=js"

import "./ResidentVital.vue?vue&type=style&index=0&id=dff56882&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__